import { Button, Text } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";

import { SWIPER_SLIDE_CHANGE_SPEED } from "../constants";
import { swiperAtom } from "../store";
import css from "../WelcomeModal.module.scss";

interface SliderPrevNextButtonsProps {
  handleCloseWelcomeModal: (value?: boolean) => void;
}

export const SliderPrevNextButtons = ({
  handleCloseWelcomeModal,
}: SliderPrevNextButtonsProps) => {
  const [swiperRef] = useAtom(swiperAtom);

  return (
    <div className={css.sliderPrevNextButtonsContainer}>
      <Button
        view="outlined"
        width="max"
        size="l"
        disabled={swiperRef?.activeIndex ? swiperRef.activeIndex <= 0 : true}
        onClick={() => swiperRef?.slidePrev(SWIPER_SLIDE_CHANGE_SPEED)}
      >
        <Text variant="subheader-1">Назад</Text>
      </Button>
      <Button
        view="action"
        width="max"
        size="l"
        onClick={() => {
          if (swiperRef?.isEnd) return handleCloseWelcomeModal();
          swiperRef?.slideNext(SWIPER_SLIDE_CHANGE_SPEED);
        }}
      >
        <Text variant="subheader-1">
          {swiperRef?.isEnd ? "Завершить" : "Дальше"}
        </Text>
      </Button>
    </div>
  );
};
